export enum ProductUnavailableReasonCodes {
  ALCOHOL_LESS_THAN_REQUIRED_QUANTITY = 'ALCOHOL_LESS_THAN_REQUIRED_QUANTITY',
  ALCOHOL_PROHIBITED_PERIOD = 'ALCOHOL_PROHIBITED_PERIOD',
  EXPIRED_ALCOHOL_LICENSE = 'EXPIRED_ALCOHOL_LICENSE',
  UNAVAILABLE_IN_RM3 = 'UNAVAILABLE_IN_RM3',
  MORE_THAN_MAX_REQUIRED = 'MORE_THAN_MAX_REQUIRED'
}

export enum CollectionType {
  NONE = 'NONE',
  LOYALTY = 'LOYALTY',
  PROMOTION = 'PROMOTION',
  IMAGE_LEFT_RIBBON = 'IMAGE_LEFT_RIBBON',
  IMAGE_RIGHT_RIBBON = 'IMAGE_RIGHT_RIBBON',
  PROPOINT_PROMOTION = 'PROPOINT_PROMOTION'
}
